<template>
	<div>
		<ly-datalist url="article" infourl="article_add" title="文章列表" add="yes" addtxt="新建文章" :formdata="formdata">
			<div class="row">
				<div class="col-md-10">
					<form class="form-horizontal">
						<div class="col-md-6 form-group tl">
							<label class="col-sm-2 tl c-grey mt8">筛选</label>
							<div class="col-sm-4 tl">
						    	<select class="form-control" v-model="formdata.type">
						    		<option value="all">全部</option>
									<option :value="el.type" v-for="el in typeArr">{{el.type_name}}</option>
						    	</select>
							</div>
						</div>
					</form>
				</div>
			</div>
			<div class="form-hr"></div>
			<table class="table">
		        <thead>
		          <tr>
		            <th>资讯标题 </th>
		            <th>分类</th>
		            <th>发布日期</th>
		            <th>发布人</th>
		            <th>阅读量</th>
		            <th>上下架</th>
		            <th>操作</th>
		          </tr>
		        </thead>
		        <tbody>
		        	<tr v-for="item in data">
			            <td>{{item.title}}</td>
			            <td>{{item.type}}</td>
			            <td>{{item.publish_time}}</td>
			            <td>{{item.publisher}}</td>
			            <td>{{item.viewed}}</td>
			            <td v-if="item.status==1">上架</td>
			            <td v-else>下架</td>
			            <td><a  v-link="{name:'article_info',params : {aid: item.id}}" class="button">查看</a></td>
			        </tr>
		        </tbody>
		    </table>
		</ly-datalist>
	</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js'); 
	/**
	* 组件对象
	*/
	var Component = {
		data : function(){
			return {
				data : [],
				formdata: {
					type: "all"
				},//文章类型
				typeArr: []
			}
		},
		ready: function(){
			var self = this;
			Http['articlecategory'].query({
				succ: function(rs) {
					self.typeArr = rs;
				}
			});
		},
		components :  {
			'ly-datalist' : require('../components/Datalist.vue')
		},
		events : {
			datalist : function(data){
				this.data = data;
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** article_list.vue?cf545ef2
 **/